import { CommonModule } from '@angular/common';
import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { KeycloakService } from 'keycloak-angular';
import { DialogService } from 'src/app/dialogservice.service';
import { AgentsService } from 'src/app/utils/services/agents.service';
import { BookableTimeSlotsService } from 'src/app/utils/services/bookable-time-slots.service';
import { SharedService } from 'src/app/utils/services/shared.service';
import { AgentStatusTransitionService } from 'src/app/utils/services/agent-status-transition.service';
import { DragAndDropCardComponent } from '../drag-and-drop-card/drag-and-drop-card.component';
import { SkeletonModule } from '@syncfusion/ej2-angular-notifications';
import { SpinnerComponent } from 'src/app/spinner/spinner.component';

@Component({
  selector: 'drag-and-drop-card-list',
  standalone: true,
  imports: [CommonModule, DragAndDropCardComponent, SkeletonModule, SpinnerComponent],
  templateUrl: './drag-and-drop-card-list.component.html',
  styleUrls: ['./drag-and-drop-card-list.component.scss'],
})
export class DragAndDropCardListComponent implements OnInit {
  @Input()
  public id: string;

  @Input()
  public headerText: any;

  @Input()
  public data: any;

  @ContentChild('cardTemplate', { static: true })
  public cardTemplate!: TemplateRef<any>;

  @Output()
  public dropEntry: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  scheduledCount: number = 0;

  @Input()
  terminAgentsCount: number = 0;

  @Input()
  isVgProject: boolean = false;

  headersArray: { header: string; collapsed: boolean }[] = [];
  currentUser: string = '';
  currentRole: string = '';
  isSpinnerActive: boolean = false;

  public constructor(
    public dialogService: DialogService,
    public sharedService: SharedService,
    private btsService: BookableTimeSlotsService,
    private keyCloak: KeycloakService,
    public agentService: AgentsService,
    public snackBar: MatSnackBar,
    private agentStatusTransitionService: AgentStatusTransitionService
  ) {
    this.id = '';
    this.headerText = '';
    // this.data = [];
  }

  ngOnInit(): void {
    if (this.headerText.name === 'ApplicantRejected'){
      this.isSpinnerActive = true;
    }
    this.sharedService.negativeAgentsFetchedSubject$.subscribe((res) => {
      if(res === true && this.headerText.name === 'ApplicantRejected'){
        this.isSpinnerActive = false;
      }
    })
    const tokenData = this.keyCloak.getKeycloakInstance().tokenParsed;
    const userRoles = tokenData?.realm_access?.roles;
    this.currentUser = tokenData?.['email'];

    if (userRoles?.includes('Client')) {
      this.currentRole = 'Client';
    } else if (userRoles?.includes('Partner')) {
      this.currentRole = 'Partner';
    } else if (userRoles?.includes('Admin')) {
      this.currentRole = 'Admin';
    }
    this.currentUser = tokenData?.['email'];
  }
  public onDragStart(event: any, entry: any): void {
    const eventData = {
      id: this.id,
      data: entry,
    };
    event.dataTransfer.setData('cards-entry', JSON.stringify(eventData));
    event.dataTransfer.effectAllowed = 'move';
  }

  public allowDrop(event: any): void {
    event.preventDefault();
    if (this.currentRole === 'Partner') {
      event.dataTransfer.dropEffect = 'none';
    }
  }

  public onDrop(event: any): void {
    event.preventDefault();

    const eventData = event.dataTransfer.getData('cards-entry');
    if (!eventData) {
      return;
    }

    const parsedEventData = JSON.parse(eventData);
    if (!parsedEventData) {
      return;
    }
    const dropAllow = this.isAllowDrop(
      parsedEventData.id,
      this.id,
      parsedEventData.data
    );
    if (this.dropEntry && !dropAllow) {
      return;
    }
    this.dropEntry.emit({
      from: parsedEventData.id,
      to: this.id,
      data: parsedEventData.data,
    });
  }

  /**
   * Prüft, ob das Verschieben eines Agenten zwischen Spalten erlaubt ist
   * 
   * @param fromColumn - Die Quellspalte, aus der der Agent verschoben wird
   * @param toColumn - Die Zielspalte, in die der Agent verschoben werden soll
   * @param agent - Das Agent-Objekt, das verschoben werden soll
   * @returns {boolean} - True, wenn das Verschieben erlaubt ist, sonst False
   */
  isAllowDrop(fromColumn: string, toColumn: string, agent: any): boolean {
    const allowMove = this.agentStatusTransitionService.isStatusTransitionAllowed(
      fromColumn, 
      toColumn, 
      this.currentRole, 
      agent
    )

    // Spezialfall: Einen Agenten ohne Voicefile in 'ApplicantGetsSuggested' verschieben
    if (!allowMove && fromColumn === 'WaitingForAgent' && toColumn === 'ApplicantGetsSuggested') {
      this.showMoveAgentWithoutVoicefileDialog()
      return true
    }

    return allowMove
  }



  showToast(message: string) {

    this.snackBar.open(message, '', {
      duration: 5000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
    })
  }

  /**
   * Zeigt den Dialog, der fragt, ob man ohne Voicefile verschieben möchte
   */
  private showMoveAgentWithoutVoicefileDialog() {

    this.dialogService.performDropAction = false
    this.dialogService.showMoveAgentWithoutVoicefileDialog = true
  }
}
